<template>
  <v-col
    cols="4"
  >
    <v-card>
      <v-card-title>
        Schedule
      </v-card-title>
      <v-card-text>
        Presentations will be
        <SecondsToMinutes
          :seconds="presentationTimeSeconds"
        />
        long.
      </v-card-text>
      <v-card-actions>
        <v-dialog
          v-model="dialog"
          max-width="1000px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="view-schedule-button"
              v-bind="attrs"
              v-on="on"
            >
              View schedule
            </v-btn>
          </template>
          <Schedule />
        </v-dialog>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
import SecondsToMinutes from '@/components/SecondsToMinutes.vue';
import Schedule from '@/components/Schedule.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'ScheduleCallToAction',
  components: {
    SecondsToMinutes,
    Schedule,
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    ...mapGetters({
      presentationTimeSeconds: 'presentationTimeSeconds',
    }),
  },
};
</script>

<style lang="scss" scoped>
  .v-card__title {
    padding-bottom: 0;
  }

  .view-schedule-button {
    background-color: #004e7d!important;
    color: #fff!important;

    ::v-deep .v-btn__content {
      text-transform: uppercase;
    }
  }

  .v-card__actions {
    padding: 0 1rem 1rem 1rem;
  }
</style>
